<template>
  <div class="obody">
    <HomePageTop></HomePageTop>

    <div class="registerMainBox">
      <!-- 第三步页面 -->
      <div class="registration_complete">
        <div class="registration_completeCon">
          <div class="registration_completeConOpt">
            <img class="successImg" src="@/assets/newassets/login/success.svg" alt="" />
          </div>
          <div class=" showSpan">
            <p class="p_first">
              {{ $fanyi('帐号注册完成') }}
            </p>
            <p>
              {{ $fanyi('非常感谢您的注册') }}
            </p>
          </div>
          <div class="registration_completeConOpt">
            <button @click="$fun.toPage('/login')" class="log">
              {{ $fanyi('去登录') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HomePageTop from '@/components/head/HomePageTop.vue'

export default {
  name: 'register',
  data() {
    return {}

  },

  created() {


  },
  components: {

    HomePageTop,

  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>
@import '@/css/mixin';



/deep/ .input__inner {
  border-radius: 0;
}


/deep/.el-checkbox__input {
  height: 16px;
}


.obody {
  height: 100%;
  background-color: #FAFAFA;

  .registerMainBox {
    width: 720px;
    height: 386px;
    margin: auto;
    margin-top: 40px;
    background: #FFFFFF;
    border-radius: 20px;

    .registration_complete {
      width: 100%;
      height: 100%;

      .registration_completeCon {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;


        .registration_completeConOpt {
          display: flex;
          align-items: center;
          margin-bottom: 32px;

          .successImg {
            width: 60px;
            height: 66px;
          }

        }

        .log {
          width: 320px;
          height: 56px;
          background: #D12A1D;
          border-radius: 12px;
          font-weight: normal;
          font-size: 18px;
          color: #FFFFFF;
        }

        .showSpan {
          margin-bottom: 40px;

          .p_first {
            font-weight: normal;
            font-size: 18px;
            color: #121212;
            margin-bottom: 10px;
          }

          p:nth-child(2) {
            font-weight: normal;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }
}

// 输入框验证失败样式
/deep/.is-error input {
  border-color: #ff730b !important;
}
</style>
